var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-height-0"},[_c('div',{staticClass:"wave-footer-bottom-img foreground",class:this.backgroundCustom})])}
var staticRenderFns = []

export { render, staticRenderFns }